<script lang="ts">
  import { debugMode, toggleDebug } from '../stores/debug';
</script>

<button
  onclick={toggleDebug}
  class="fixed top-3.5 right-12 z-[9999] w-6 h-6 rounded-full flex items-center justify-center text-xs cursor-pointer transition-all
    {$debugMode ? 'bg-error text-white shadow-lg' : 'bg-bg-card text-text-muted border border-border hover:text-text-secondary'}"
  aria-label="Toggle debug logging"
  title={$debugMode ? 'Debug ON — click to disable' : 'Debug OFF — click to enable'}
>
  🐛
</button>
